import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import '@fortawesome/fontawesome-free/css/all.min.css';

import Navbar from './Components/MainComp/navbar';
import Footer from './Components/MainComp/footer';
import Body from './Components/BodyComp/body';
import AboutUs from './Components/AboutComp/aboutus';
import ContactUs from './Components/ContactComp/contactus';
import Project from './Components/ProjectsComp/projects';
import Services from './Components/ServicesComp/services';
import WhatsAppButton from './Components/Whatsapp/WhatsAppButton';

import PrivacyPolicy from './Components/InformationComp/privacy-policy';
import TermsOfServices from './Components/InformationComp/terms-of-services';
import CookiePolicy from './Components/InformationComp/cookie-policy';

// Removed the `export const`, now it's just a const declaration
const App = () => {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Body />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/contactus" element={<ContactUs />} />
        <Route path="/projects" element={<Project />} />
        <Route path="/services" element={<Services />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-services" element={<TermsOfServices />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} /> 
      </Routes>
      <WhatsAppButton />
      <Footer />
     
    </Router>
  );
};

// This is the key fix: Changed to a default export
export default App;